// extracted by css-extract-rspack-plugin
export default {"mobileWarning":"C97tAYzfoPdeLxj_","mobileWarningContents":"Zp5Ul4O9T0IRGAGr","mobileWarningContentsIcon":"BPMnhm6veik5KZNd"};